/* eslint max-classes-per-file: 0 */

import {
  NotificationBanner as Data,
  NotificationBannerCollection as Collection,
} from '@/typings/api/NotificationBanner'
import { NotificationsBannersApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class NotificationBannersTransformerParams extends TransformerParams {
}

export class NotificationBannersAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new NotificationBannersTransformerParams();
}
